// import _ from "lodash";
// import * as d3Scale from "d3-scale";
import slugify from 'slugify'

export default class DataHelper {
  constructor(name) {
    this.name = name;
  }

  static getFiltersState(rootGetters) {
    return {
      mainSource: rootGetters["ui/mainSource"],
      source: rootGetters["ui/source"],
      dataType: rootGetters["ui/dataType"],
      geoArea: rootGetters["ui/geoArea"],
      currentSourceConfig: rootGetters["ui/currentSourceConfig"],
    };
  }

  //DATA UTILS
  static parseNumericValues(data, dataKey) {
    return data.map((x) => {
      return {
        ...x,
        [dataKey]:
          parseFloat(parseFloat(x[dataKey].replace(",", ".")).toFixed(2)) || 0,
      };
    });
  }
  static parsePercValues(data, dataKey) {
    return data.map((x) => {
      return {
        ...x,
        [dataKey]: parseFloat(x[dataKey].split("%")[0].replace(",", ".")) || 0,
      };
    });
  }

  static filterByMainSource(data, filterValue) {
    return this.filterDatasetByProp(data, filterValue, "MAINSOURCE");
  }

  static filterByGeoArea(data, filterValue) {
    //[NB] check on geoArea is with includes, not equal because in the data we have "North Americas" and "Central South Americas"
    return this.filterDatasetByProp(data, filterValue, "AREA", true);
  }

  static filterBySource(data, filterValue) {
    let res = data;
    if (filterValue) {
      res = this.filterDatasetByProp(data, filterValue, "SOURCE");
    }
    return res;
  }
  static filterByDataType(data, filterValue) {
    let res = data;
    if (filterValue) {
      return this.filterDatasetByProp(data, filterValue, "TYPE");
    }
    return res;
  }

  static filterDatasetByProp(data, value, dataKey, shallowFilter = false) {
    if (!shallowFilter) {
      return data.filter((x) => x[dataKey] === value);
    } else {
      return data.filter(
        (x) =>
          x[dataKey].includes(value) ||
          x[dataKey].split(" ")[0].includes(value.split(" ")[0])
      );
    }
  }

  static sumByPropery(data, dataKey_sum, dataKey_group) {
    // first, convert data into a Map with reduce
    const counts = data.reduce((prev, curr) => {
      let count = prev.get(curr[dataKey_group]) || 0;
      prev.set(curr[dataKey_group], curr[dataKey_sum] + count);
      return prev;
    }, new Map());

    // then, map your counts object back to an array
    const res = [...counts].map(([key, value]) => {
      return {
        [dataKey_group]: key,
        [dataKey_sum]: value,
      };
    });

    return res;
  }

  static calcQTYPercChangeByDeltaYear(data, currentYear, previousYearIndex) {
    const previousYear = data[previousYearIndex]

    if (previousYear) {
      const delta = (currentYear.QTY / previousYear.QTY) * 100;
      return {
        DELTA_VALUE_PERC: (delta - 100),
        REFERENCE_YEARS: [currentYear.YEAR, previousYear.YEAR],
      };
    } else {
      return null;
    }
  }

  static getCountryGeoCoords(item, circleSize, countryRegistry) {
    let COORDS = {
      type: "Feature",
      id: item.ID,
      geometry: {
        type: "Point",
        coordinates: [],
      },
      properties: {
        QTY: item.QTY,
        RADIUS_TARGET: circleSize,
        RADIUS_CURRENT: 0,
        country: item.COUNTRY,
      },
    };

    const c = countryRegistry.find((x) => slugify(x.country) === slugify(item.COUNTRY));

    if (c) {
      COORDS.geometry.coordinates = [c.longitude, c.latitude];
    } else {
      console.log("COUNTRY COORDS NOT FOUND FOR", item.COUNTRY);
      COORDS.geometry.coordinates = null;
    }

    return COORDS;
  }

  static filterAwayZeroOrNull(dataset, dataKey) {
    return dataset.filter((x) => x[dataKey] > 0 && x[dataKey] !== "");
  }
}
